<fieldset>
    <legend>
        {{ step1.getspan1 | translate }}
    </legend>
    <app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="avisInitial?.idWeb"
        [label]="step1.getidweb" [type]="'text'" [rule]="'pattern_9|required'"
        [errorMessage]="{'pattern' : 'ctr_pattern9'}" [name]="getUid() + '_SepAtt_idWeb'">
    </app-form-input>

    <app-form-input *ngIf="false" [parentForm]="parentForm" [disabled]="disabled"
        [value]="avisInitial?.edition" [label]="'edition'" [type]="'text'" [rule]="''"
        [name]="getUid() + '_SepAtt_edition'">
    </app-form-input>
    <app-form-input *ngIf="false" [parentForm]="parentForm" [disabled]="disabled"
        [value]="avisInitial?.numAnnParution" [label]="'numAnnParution'" [type]="'number'"
        [rule]="''" [name]="getUid() + '_SepAtt_numAnnParution'">
    </app-form-input>
    <app-form-input *ngIf="false" [parentForm]="parentForm" [disabled]="disabled"
        [value]="avisInitial?.parution" [label]="'parution'" [type]="'number'" [rule]="''"
        [name]="getUid() + '_SepAtt_parution'">
    </app-form-input>
    <app-form-input [parentForm]="parentForm" [disabled]="disabled"
        [value]="avisInitial?.datePublication" [label]="step1.getdatepublication"
        [type]="'date'" [rule]="''" [name]="getUid() + '_SepAtt_datePublication'">
    </app-form-input>
    <app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg1" [id]="getStepId() + rg1"></app-form-input-error>
</fieldset>